import React from "react";
import { FetchStatus } from "../util/FetchStatus.mjs";
import ErrorUtil from "../util/ErrorUtil.mjs";
const DEFAULT_INVOICE_SETTINGS_STATE = {
  invoiceSettings: [],
  status: FetchStatus.UNINITIALIZED
};
const InvoiceProvider = (props) => {
  const { commonApi } = props;
  const [invoiceSettingsState, setInvoiceSettingsState] = React.useState(DEFAULT_INVOICE_SETTINGS_STATE);
  const fetchInvoiceSettings = async () => {
    setInvoiceSettingsState({ ...DEFAULT_INVOICE_SETTINGS_STATE, status: FetchStatus.FETCHING });
    try {
      const { data } = await commonApi.get("/invoice/settings");
      setInvoiceSettingsState({ ...data, status: FetchStatus.FETCHED });
    } catch (e) {
      setInvoiceSettingsState({ ...DEFAULT_INVOICE_SETTINGS_STATE, status: FetchStatus.ERROR });
      ErrorUtil.pushErrorToTeliaRumAndLog(e);
    }
  };
  return /* @__PURE__ */ React.createElement(InvoicesContext.Provider, { value: { invoiceSettingsState, fetchInvoiceSettings } }, props.children);
};
const InvoicesContext = React.createContext({
  invoiceSettingsState: DEFAULT_INVOICE_SETTINGS_STATE,
  fetchInvoiceSettings: () => void 0
});
const useInvoices = () => {
  return React.useContext(InvoicesContext);
};
export {
  InvoiceProvider,
  InvoicesContext,
  useInvoices
};
